import React from 'react'
import './TradersCardOverview.scss'
import { useAuth } from 'Components/AuthProvider/AuthProvider'
import { useNavigate } from 'react-router-dom'
import tradersCardWordmark from 'Assets/Images/Dashboard/overview-pages/traderscard/traderscard-wordmark.png'
import tradersCardBannerCard from 'Assets/Images/Dashboard/overview-pages/traderscard/traderscard-banner-card.png'
import arrowUpGreen from 'Assets/Images/Dashboard/overview-pages/traderscard/arrow-up-green.svg'

type TxStatus = 'Pending' | 'Success'

const TradersCardOverview = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const name = user?.user?.name ?? 'Admin'

  const tabs: Array<{ label: string; active: boolean; onClick?: () => void }> = [
    { label: 'TradeGrid Boost', active: false, onClick: () => navigate('/general-overview/boost-overview') },
    { label: 'TradersCard', active: true },
    { label: 'TradeGrid Plus', active: false, onClick: () => navigate('/general-overview/tgplus-overview') },
    { label: 'BoostXpress', active: false, onClick: () => navigate('/general-overview/boostxpress-overview') },
  ]

  const topRow: Array<{ label: string; value: string; deltaText: string }> = [
    { label: 'Total Number of TradersCard Requests', value: '135,000', deltaText: '+100 new users' },
    { label: 'Total Number of Users', value: '11,500', deltaText: '+100 new users' },
    { label: 'Total amount disbursed (Naira)', value: '1,500,000', deltaText: '+100' },
    { label: 'Total Margin on Orders', value: '1,500', deltaText: '+100' },
    { label: 'Total TradersCard Orders', value: '155,000 L', deltaText: '+10L' },
  ]

  const bottomRow: Array<{ label: string; value: string; deltaText: string }> = [
    { label: 'Total Lease agreement', value: '15', deltaText: '+100 new users' },
    { label: 'Asset Pool Size', value: '1,500', deltaText: '+100 new users' },
    { label: 'Return on Investment', value: '1,500', deltaText: '+100 new users' },
    { label: 'Investment Liquidated', value: '1,500', deltaText: '+100 new users' },
    { label: 'Payouts', value: '1,500', deltaText: '+100 new users' },
  ]

  const transactions: Array<{
    amount: string
    date: string
    product: string
    status: TxStatus
  }> = [
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Traderscard', status: 'Pending' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Traderscard', status: 'Success' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Traderscard', status: 'Success' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Traderscard', status: 'Success' },
  ]

  const usersList: Array<{ name: string; msisdn: string; acctType: string }> = [
    { name: 'John Doe', msisdn: '08123456789', acctType: 'Product' },
    { name: 'John Doe', msisdn: '08123456789', acctType: 'Product' },
    { name: 'John Doe', msisdn: '08123456789', acctType: 'Product' },
    { name: 'John Doe', msisdn: '08123456789', acctType: 'Product' },
    { name: 'John Doe', msisdn: '08123456789', acctType: 'Product' },
  ]

  return (
    <div className='traderscard-overview-page'>
      <div className='container traderscard-overview-page__container'>
        <div className='traderscard-banner'>
          <div className='traderscard-banner__content'>
            <div className='traderscard-banner__welcome'>Welcome Back, {name}</div>
            <div className='traderscard-banner__subtitle'>Here&apos;s your Traderscard summary</div>
          </div>
          <img src={tradersCardBannerCard} className='traderscard-banner__art' />
        </div>

        <div className='traderscard-summary-card'>
          <img src={tradersCardWordmark} className='traderscard-summary-card__logo' />

          <div className='traderscard-metrics'>
            {topRow.map((m) => (
              <div className='traderscard-metric' key={m.label}>
                <div className='traderscard-metric__label'>{m.label}</div>
                <div className='traderscard-metric__value'>{m.value}</div>
                <div className='traderscard-metric__delta'>
                  <img src={arrowUpGreen} className='traderscard-metric__delta-icon' />
                  <span className='traderscard-metric__delta-up'>5%</span>
                  <span className='traderscard-metric__delta-text'>{m.deltaText}</span>
                </div>
              </div>
            ))}
          </div>

          <div className='traderscard-metrics traderscard-metrics--second'>
            {bottomRow.map((m) => (
              <div className='traderscard-metric' key={m.label}>
                <div className='traderscard-metric__label'>{m.label}</div>
                <div className='traderscard-metric__value'>{m.value}</div>
                <div className='traderscard-metric__delta'>
                  <img src={arrowUpGreen} className='traderscard-metric__delta-icon' />
                  <span className='traderscard-metric__delta-up'>5%</span>
                  <span className='traderscard-metric__delta-text'>{m.deltaText}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className='row g-4 traderscard-bottom'>
          <div className='col-12 col-lg-7'>
            <div className='traderscard-tabs'>
              {tabs.map((t) => (
                <button
                  key={t.label}
                  className={`traderscard-tab ${t.active ? 'traderscard-tab--active' : ''}`}
                  type='button'
                  onClick={t.onClick}
                >
                  {t.label}
                </button>
              ))}
            </div>

            <div className='traderscard-section-title'>
              <div className='traderscard-section-title__left'>Recent Transactions</div>
              <div className='traderscard-section-title__right'>View all</div>
            </div>

            <div className='traderscard-table-card'>
              <div className='traderscard-table-card__head'>
                <div className='traderscard-table-card__col traderscard-table-card__col--amount'>
                  Amount
                </div>
                <div className='traderscard-table-card__col traderscard-table-card__col--date'>
                  Date
                </div>
                <div className='traderscard-table-card__col traderscard-table-card__col--product'>
                  Product
                </div>
                <div className='traderscard-table-card__col traderscard-table-card__col--status'>
                  Status
                </div>
              </div>

              <div className='traderscard-table-card__body'>
                {transactions.map((tx, idx) => (
                  <div
                    className={`traderscard-tx-row ${idx % 2 === 0 ? 'traderscard-tx-row--alt' : ''}`}
                    key={`${tx.product}-${idx}`}
                  >
                    <div className='traderscard-tx-row__col traderscard-tx-row__col--amount'>
                      {tx.amount}
                    </div>
                    <div className='traderscard-tx-row__col traderscard-tx-row__col--date'>
                      {tx.date}
                    </div>
                    <div className='traderscard-tx-row__col traderscard-tx-row__col--product'>
                      {tx.product}
                    </div>
                    <div className='traderscard-tx-row__col traderscard-tx-row__col--status'>
                      <div
                        className={`traderscard-status ${
                          tx.status === 'Pending'
                            ? 'traderscard-status--pending'
                            : 'traderscard-status--success'
                        }`}
                      >
                        {tx.status}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className='col-12 col-lg-5'>
            <div className='traderscard-users-card'>
              <div className='traderscard-users-card__header'>
                <div className='traderscard-users-card__title'>Recent Users</div>
                <div className='traderscard-users-card__action'>View all</div>
              </div>

              <div className='traderscard-users-card__table'>
                <div className='traderscard-users-card__row traderscard-users-card__row--head'>
                  <div className='traderscard-users-card__cell traderscard-users-card__cell--name'>
                    Name
                  </div>
                  <div className='traderscard-users-card__cell traderscard-users-card__cell--msisdn'>
                    MSISDN
                  </div>
                  <div className='traderscard-users-card__cell traderscard-users-card__cell--acct'>
                    Acct.Type
                  </div>
                </div>

                {usersList.map((u, idx) => (
                  <div className='traderscard-users-card__row' key={`${u.msisdn}-${idx}`}>
                    <div className='traderscard-users-card__cell traderscard-users-card__cell--name'>
                      {u.name}
                    </div>
                    <div className='traderscard-users-card__cell traderscard-users-card__cell--msisdn'>
                      {u.msisdn}
                    </div>
                    <div className='traderscard-users-card__cell traderscard-users-card__cell--acct'>
                      {u.acctType}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className='traderscard-footer'>© 2026 Tradegrid - All rights reserved.</div>
      </div>
    </div>
  )
}

export default TradersCardOverview

